import React, {
  useState,
  useEffect,
  createContext,
  FunctionComponent,
  PropsWithChildren,
} from 'react';

// Analytics
import AnalyticsService from './Analytics';
import defaultAnalyticsConfig from './analytics-config';
import packageJson from '../../package.json';

export const AnalyticsContext = createContext<AnalyticsService | null>(null);

export const AnalyticsContextProvider: FunctionComponent<PropsWithChildren> = ({
  children,
}) => {
  const [analytics, setAnalytics] = useState<AnalyticsService>(
    new AnalyticsService(defaultAnalyticsConfig, packageJson.version)
  );

  // const analyticsService = new AnalyticsService(
  //   defaultAnalyticsConfig,
  //   packageJson.version
  // );

  // useEffect(() => {
  //   const newAnalytics = new AnalyticsService(
  //     defaultAnalyticsConfig,
  //     packageJson.version
  //   );

  //   setAnalytics(newAnalytics);
  // }, []);

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};
